import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import css from './ChatBotSideBar.module.css';
import { FormattedMessage } from 'react-intl';
import { Button, IconCollection, NamedLink } from '../../../components';
import ProfileIconCard from '../../../components/ProfileIconCard/ProfileIconCard';
import { capitalizeWords, getLastThreeRecentChats } from '../../../util/data';
import { PRIMARY_RULEBOOK_GROUP_ID, MY_FAVOURITE, RECENT_CHATS } from '../../../util/types';
import { v4 as uuidv4 } from 'uuid';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';

const ChatBotSideBar = (props) => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const [gptSections, setGptSection] = useState([MY_FAVOURITE, RECENT_CHATS]);
  const [openDropDwon, setOpenDropDwon] = useState([]);

  const {
    chatDetails,
    isSideBarOpen,
    userFavChatDetails,
    scrollToSection,
    params,
    userChatDetails,
    currentUser
  } = props;
  const { favGpt = [], gpts = [] } = userFavChatDetails || {};
  const favFileIds = favGpt?.map((chat) => chat.rulebook_id) || [];
  const favChats = gpts?.filter((e) => favFileIds?.includes(e.rulebook_id)) || [];

  const recentChats = userChatDetails?.chatData ? userChatDetails?.chatData : chatDetails;
  const recentSessions = getLastThreeRecentChats(recentChats);


  const toggleFunction = (selectedSection) => {
    setGptSection(prev =>
      prev.includes(selectedSection)
        ? prev.filter(item => item !== selectedSection)  // Remove if exists
        : [...prev, selectedSection]                    // Add if not exists
    );
  };

  return (
    <>
      <div className={`${css.sideBar} ${isSideBarOpen ? css.open : ''}`}>
        <div className={css.aisideBarHeading}>TurnoutAI Menu</div>
        <NamedLink name="RuleBooksSearchPage" params={{ rulebookId: 'all' }} className={params?.rulebookId === 'all' ? css.activeLink : ''}>
          <div className={css.content}>
            <span className={css.icon}>
              <IconCollection name="ruleBookIcon" />
            </span>
            <FormattedMessage id="ChatBotSideBar.rulebooks" />
          </div>
        </NamedLink>
        {currentUser ? (
          <NamedLink name="FavouritePage" params={{ rulebookId: 'favourites' }} className={params?.rulebookId == 'favourites' ? css.activeLink : ''}>
            <div className={css.content}>
              <span className={css.icon}>
                <IconCollection name="myFavouriteIcon" />
              </span>
              <FormattedMessage id="ChatBotSideBar.myFavourites" />
            </div>
          </NamedLink>) : null
        }
        <NamedLink name="AiChatBotRulebookPage" params={{ rulebookId: PRIMARY_RULEBOOK_GROUP_ID, sessionId: uuidv4() }} className={params?.rulebookId == PRIMARY_RULEBOOK_GROUP_ID ? css.activeLink : ''}>
          <div className={css.content}>
            <span className={css.icon}>
              <ProfileIconCard type="feed" />
            </span>
            <FormattedMessage id="ChatBotSideBar.generalChat" />

          </div>
        </NamedLink>
        <div className={css.buttonContainer}>
          <Button className={css.requestButton} onClick={scrollToSection} disabled={!(currentUser && currentUser.id)}><FormattedMessage id="ChatBotSideBar.requestRuleBook" /></Button>
          <div className={css.spacer}></div>
          {!(currentUser && currentUser.id) && (
            <>
              <Button
                className={css.authButton}
                onClick={() => history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}, {}))}
              >
                <ProfileIconCard type="join_now" />
                <FormattedMessage id="ChatBotSideBar.joinNow" defaultMessage="Join Now" />
              </Button>
              <Button
                className={css.authButton}
                onClick={() => history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}))}
              >
                <ProfileIconCard type="join_now" />

                <FormattedMessage id="ChatBotSideBar.login" defaultMessage="Log In" />
              </Button>
            </>
          )}
        </div>

        {(favChats && favChats.length > 0) ?
          <div className={css.favChatsContainer}>
            <>
              <span onClick={() => toggleFunction(MY_FAVOURITE)}
                className={css.sectionTitle}
              >
                <FormattedMessage id="ChatBotSideBar.myFavouritesSection" />
                {gptSections.includes(MY_FAVOURITE) ? <span className={css.sectionCount}>-</span> : <span className={css.sectionCount}>+</span>}
              </span>
              {gptSections.includes(MY_FAVOURITE) ? <ul className={css.sectionContent}>
                {favChats?.map((gpt) => {
                  return (
                    <div>
                      <li onClick={() => {
                        setOpenDropDwon(prev =>
                          prev.includes(gpt?.rulebook_name)
                            ? prev.filter(item => item !== gpt?.rulebook_name)  // Remove if exists
                            : [...prev, gpt?.rulebook_name]                    // Add if not exists
                        );
                      }}>
                        <IconCollection name={"roundIcon"} />
                        <div className={css.arrowIconWrapper}>
                          {capitalizeWords(gpt?.rulebook_name)}
                          {openDropDwon.includes(gpt?.rulebook_name) ? <IconCollection name={"downColorArrowIcon"} /> : <IconCollection name={"downArrowIcon"} />}</div>
                      </li>
                      {openDropDwon.includes(gpt?.rulebook_name) ? <div className={css.sectionSubContent}>
                        <NamedLink name="AiChatBotRulebookPage" params={{ rulebookId: gpt?.rulebook_id, sessionId: uuidv4() }}>
                          <><span className={css.dot}></span><FormattedMessage id="ChatBotSideBar.startChat" /></>
                        </NamedLink>
                        {(recentChats.filter((e) => e.rulebook_id == gpt?.rulebook_id) && recentChats.filter((e) => e.rulebook_id == gpt?.rulebook_id).length > 0) ?
                          <>
                            {Object.entries(
                              recentChats.filter((e) => e.rulebook_id == gpt?.rulebook_id).reduce((acc, chat) => {
                                if (!acc[chat.session_id]) acc[chat.session_id] = [];
                                acc[chat.session_id].push(chat);
                                return acc;
                              }, {})
                            )
                              .slice(-2) // Keep only the last 3 recent chats
                              .reverse()
                              .map(([sessionId, chats]) => (
                                <NamedLink
                                  key={sessionId}
                                  name="AiChatBotRulebookPage"
                                  params={{ rulebookId: chats[0]?.rulebook_id, sessionId }}
                                >
                                  <><span className={css.dot}></span>
                                    {chats[0]?.query}
                                  </>
                                </NamedLink>
                              ))}
                          </> : null}
                      </div> : null}
                    </div>
                  )
                })}
              </ul> : null}
            </>

          </div>
          : null
        }

        {(recentChats && recentChats.length > 0) ? (
          <div>
            <>
              <span
                onClick={() => toggleFunction(RECENT_CHATS)}
                className={css.sectionTitle}
              >
                <FormattedMessage id="ChatBotSideBar.recentChats" />
                {gptSections.includes(RECENT_CHATS) ? (
                  <span className={css.sectionCount}>-</span>
                ) : (
                  <span className={css.sectionCount}>+</span>
                )}
              </span>

              {gptSections.includes(RECENT_CHATS) ? (
                <ul className={css.sectionContent}>
                  {/* Group chats by session_id */}
                  {recentSessions.map((latestChat) => {
                    const sessionId = latestChat.session_id;
                    const rulebookId = latestChat.rulebook_id;
                    return (
                      <NamedLink
                        key={sessionId}
                        name="AiChatBotRulebookPage"
                        params={{
                          rulebookId: rulebookId || "1111",
                          sessionId: sessionId || "1111"
                        }}
                      >
                        <li>
                          <IconCollection name="recentRoundIcon" />
                          {latestChat.query}
                        </li>
                      </NamedLink>
                    );
                  })}
                </ul>
              ) : null}
            </>
          </div>
        ) : null}

      </div>
    </>
  );
};

export default ChatBotSideBar;
